// Lightweight handoff between the Payment step and downstream signup steps
// (Account, Onboarding). Persisted to localStorage so a tab refresh between
// steps doesn't lose customer context. NOTE: this is not a security boundary —
// any user can write to localStorage. The backend must independently verify
// the PaymentIntent succeeded before granting account access.
export const STARTER_PAY_CONTEXT_KEY = "snug.starter-pay.context";

export interface StarterPayContext {
  name: string;
  company: string;
  email: string;
  plan: string;
  planLabel: string;
  paymentSchedule: "single" | "split";
  paymentIntentId?: string;
  proGroupId?: string;
}

export function readStarterPayContext(): StarterPayContext | null {
  try {
    const raw = window.localStorage.getItem(STARTER_PAY_CONTEXT_KEY);
    if (!raw) {
      console.warn("[SIGNUP-TRACE] readStarterPayContext: NOTHING in localStorage");
      return null;
    }
    const parsed = JSON.parse(raw) as StarterPayContext;
    console.log("[SIGNUP-TRACE] readStarterPayContext ->", { email: parsed?.email, proGroupId: parsed?.proGroupId });
    return parsed;
  } catch (e) {
    console.error("[SIGNUP-TRACE] readStarterPayContext PARSE FAILED", e);
    return null;
  }
}

export function writeStarterPayContext(ctx: StarterPayContext): void {
  console.log("[SIGNUP-TRACE] writeStarterPayContext <-", { email: ctx?.email, proGroupId: ctx?.proGroupId });
  window.localStorage.setItem(STARTER_PAY_CONTEXT_KEY, JSON.stringify(ctx));
}

export function clearStarterPayContext(): void {
  window.localStorage.removeItem(STARTER_PAY_CONTEXT_KEY);
}
